import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { register } from 'swiper/element/bundle';
import { useTranslation } from 'react-i18next';
import axiosInstance, { API_ENDPOINTS, ASSETS_API, HOST_API } from '../axios/axiosInstance';
register();

export const Slider = () => {
  const { t } = useTranslation();
  const swiperElRef = useRef(null);
  const [sliderImages,SetSliderImages] = useState([]);
  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(HOST_API+API_ENDPOINTS.slider);
      SetSliderImages(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
     fetchData();
    
  }, []);
  
  return (
    <section id="slider" style={{position:'relative',height:'100vh'}}>
        <div className="book-btn">
              <Link to='/reservations' className="theme-btn">
                <span className="icon">
                  </span>
                <span className="txt">{t('home.bookTable')}</span>
              </Link>
            </div>
    <swiper-container
    
    className="swiper-wrapper"
      ref={swiperElRef}
      style={{height:'100%'}}
      slides-per-view="1"
      muted
      navigation= {{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }}
      pagination="false"
      loop
    >
      {sliderImages != null && sliderImages.length > 0 ? sliderImages.sort((a, b) => a.order - b.order)
      .map((sliderImage, sldierImageIndex) => (
        <swiper-slide key={sliderImage.id} 
          {...(sliderImage.photo !== null 
          && (sliderImage.photo.split('.').pop() !== 'mp4' 
          || sliderImage.photo.split('.').pop() !== 'm4v' 
          || sliderImage.photo.split('.').pop() !== 'avi')  
          && {style: { backgroundImage: `url(${ASSETS_API}${sliderImage.photo})`,  backgroundSize: 'cover', backgroundPosition: 'center' }}
      )}>
        { sliderImage.photo !== null 
          && (sliderImage.photo.split('.').pop() === 'mp4' 
          || sliderImage.photo.split('.').pop() === 'm4v' 
          || sliderImage.photo.split('.').pop() === 'avi')  
           &&
          (
            <>
              <video className='video-item'  id={`slider-item-${sliderImage.id}`}  style={{width:'100%'}} poster="videos/explore-poster.jpg" playsInline   onEnded={() =>window.ShowPlayButton("play-video")}   >
                <source src={`${ASSETS_API}${sliderImage.photo}`} type='video/mp4' />
            </video> 
            <div id={`play-video-${sliderImage.id}`} onClick={ (target) => window.simulateClickToPlayVideo(`slider-item-${sliderImage.id}`,`play-video-${sliderImage.id}`)} className="video-play-button">
              <span></span>
            </div></>
            
          )
         
          }
        
        </swiper-slide>)) : ""}
      
    </swiper-container>
    </section>)
};